// Web mode: the renderer in a plain browser tab (`npm run web`), no Electron shell.
// Set only by the explicit CLI flag `vite --mode web`; the Electron build runs under
// development/production mode, so this is statically false (and dead-code-eliminated) there.
// Contract: constant for the process lifetime — never flips at runtime (the web-mode branch
// in workspaces-host.jsx and the startup gates in App.jsx rely on this).
export function isWebMode() {
  return import.meta.env.MODE === 'web';
}
